// extracted by mini-css-extract-plugin
export var layout = "_8b_bu";